export default __webpack_public_path__ + "static/media/regulatory--no-lane-change-to-left--g1.c3b5e313.png";